import { EnvironmentUrls } from "Roblox";
import angular from "angular";
import chatModule from '../chatModule';

function voiceService(httpService) {
    "ngInject";

    var voiceDomain = EnvironmentUrls.voiceApi;
    return {
        isVoiceChatEligible: false,
        voiceCallId: 0,
        initVoiceSettings: function () {
            var self = this;
            var api = { url: voiceDomain + "/v2/settings", withCredentials: true };
            return httpService.httpGet(api, {}).then(function (response) {
                //make sure !! is enabled here, ! is for testing
                self.isVoiceChatEligible =  !!response.isVoiceEnabled;
                return self.isVoiceChatEligible;
            });   
        },
        isInCall: function () {
            //returns whether or not user is in some call
            return this.voiceCallId > 0;
        }
    }
};


chatModule.factory("voiceService", voiceService);

export default voiceService;
